import {
  getReq,
  postReq,
  END_POINTS
} from '@/api'
import * as StoreUtils from '@/utils/StoreUtils'

const state = {
}

const actions = {
  getChgPwdCode({
    commit,
    state,
    rootState
  }, { key }) {
    return new Promise((resolve, reject) => {
      getReq(END_POINTS.GET_CHG_PWD_CODE + `?userName=${key.userName}&mobile=${key.mobile}`)
        .then(res => {
          // state.list = res.data
          // Utils.resetListPagging(state.listPagging, res)
          StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
        }).catch(err => {
          reject(err)
        })
    })
  },
  updatePwdByMobile({
    commit,
    state,
    rootState
  }, { data }) {
    return new Promise((resolve, reject) => {
      postReq(END_POINTS.UPDATE_PWD_BY_MOBILE, {
        data
      }).then(res => {
        // state.list = res.data
        // Utils.resetListPagging(state.listPagging, res)
        StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
      }).catch(err => {
        reject(err)
      })
    })
  }
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/profile/userSecurityManage.js